import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-attr-unknown',
  templateUrl: './attr-unknown.component.html',
  styleUrls: ['./attr-unknown.component.scss'],
  standalone: false,
})
export class AttrUnknownComponent implements OnInit {
  @Input() caption: string;
  @Input() mandatory: boolean;

  constructor() {}

  ngOnInit(): void {}
}
